import React from 'react'
import type { WithChildren } from '../../models/utils'
import { ListProvider } from './ListContext'

type ListContextProviderProps = WithChildren<{}>

const ListContextProvider = ({
  children
}: ListContextProviderProps): JSX.Element => {
  return <ListProvider>{children}</ListProvider>
}

export default ListContextProvider
